var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskAltFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.8 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.138-3.175A9.7 9.7 0 0 1 2.8 12q0-2.075.787-3.9a10.1 10.1 0 0 1 2.138-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12.8 2q1.2 0 2.337.275t2.188.8q.375.2.487.6a.84.84 0 0 1-.137.75 1.1 1.1 0 0 1-.663.45 1.16 1.16 0 0 1-.812-.1 8.4 8.4 0 0 0-1.663-.575A7.7 7.7 0 0 0 12.8 4Q9.475 4 7.137 6.338T4.8 12t2.337 5.663T12.8 20t5.662-2.337T20.8 12a6 6 0 0 0-.05-.775 1.33 1.33 0 0 1 .162-.812q.213-.389.638-.513a.9.9 0 0 1 .75.075.77.77 0 0 1 .4.6A10 10 0 0 1 22.8 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137a9.7 9.7 0 0 1-3.9.788m-1.4-8.2 9.3-9.325a.98.98 0 0 1 .687-.287.93.93 0 0 1 .713.287.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L12.1 15.9q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-2.85-2.85a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.424 0 .7.275z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskAltFill);
export default __webpack_public_path__ + "static/media/task_alt_fill.aa2c25ffd9a29627fda4cd6efc7c98e5.svg";
export { ForwardRef as ReactComponent };